import React, { useState, useEffect, useContext } from "react";
import Welcome from "../Welcome/Welcome";
import Loading from "../Loading/Loading";
import VideoVR from "../VideoVR/VideoVR";
import ShouldKnow from "../ShouldKnow/ShouldKnow";
import ShouldBuy from "../ShouldBuy/ShouldBuy";
import ShouldDo from "../ShouldDo/ShouldDo";
import { wheelHandler, wheelDragDirection } from "../../Services/Wheel";
import "./Home.scss";
import { AppContext } from "../../stores/application.store";
import { GA_VPush } from "../../Services/GoogleAnalytics";

var isBusy = false;

export default function Home() {
  // let [hasLoaded, setHasLoaded] = useState(false);
  const [isScrollBusy, setScrollState] = useState(false);
  // Pages state
  let [sec1, setSec1] = useState(false);
  let [sec2, setSec2] = useState(false);
  let [sec3, setSec3] = useState(false);
  let [sec4, setSec4] = useState(false);
  let [sec5, setSec5] = useState(false);

  let dictionary = {
    "sec-1": false,
    "sec-2": false,
    "sec-3": false,
    "sec-4": false,
    "sec-5": false,
  }

  // Application Store context
  let { scroll, setScroll, inArticle, setInArticle, loading, setLoading, setHasLoaded, loaded, hasLoadedSession, setSessionLoaded } = useContext(AppContext)

  // Fix the bug that happend when going back from article via url back button
  window.onhashchange = function () {
    setScroll(scroll > 0 ? 2 : 0);
  }
  // Session storage part
  useEffect(() => {
    if (hasLoadedSession) {
      setHasLoaded(true);
      setLoading(false);
      return;
    }
    setLoading(true);
    setTimeout(() => {
      setHasLoaded(true);
    }, 6000);
    setTimeout(() => {
      setLoading(false);
    }, 7000);
    sessionStorage.setItem("hasLoaded", true);
  }, []);

  // useEffect(() => {
  //   console.log(loading);
  //   // console.log(window.history)
  //   // alert(window.screen.width);
  // }, [loading])


  useEffect(() => {
    if(!loaded) return;
    // console.log("a");
    //Sets the Observer options
    const options = {
      root: null, // The view port
      threshhold: 0, // 0 ~ 1
      rootMargin: "-100px", // like margin in css
    };
    const observer = new IntersectionObserver(function (entries, observer) {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        // Do the action on intersect section
        let currentSec = entry.target.classList[entry.target.classList.length - 1]
        switch (currentSec) {
          case "sec-1":
            if (dictionary[`sec-1`]) break;
            GA_VPush(window.location.origin + window.location.pathname + (window.location.pathname[window.location.pathname.length - 1] == "/" ? "" : "/") + "reality-check/", "בדיקת מציאות")
            dictionary[`sec-1`] = true;
            break;
          case "sec-2":
            if (dictionary[`sec-2`]) return;
            GA_VPush(window.location.origin + window.location.pathname + (window.location.pathname[window.location.pathname.length - 1] == "/" ? "" : "/") + "reality-check/what-you-should-see", "בדיקת מציאות - מה שכדאי לראות")
            dictionary[`sec-2`] = true;
            break;
          case "sec-3":
            if (dictionary[`sec-3`]) return;
            GA_VPush(window.location.origin + window.location.pathname + (window.location.pathname[window.location.pathname.length - 1] == "/" ? "" : "/") + "reality-check/what-you-should-know", "בדיקת מציאות - מה שכדאי לדעת")
            dictionary[`sec-3`] = true;
            break;
          case "sec-4":
            if (dictionary[`sec-4`]) return;
            GA_VPush(window.location.origin + window.location.pathname + (window.location.pathname[window.location.pathname.length - 1] == "/" ? "" : "/") + "reality-check/what-you-should-buy", "בדיקת מציאות - מה שכדאי לקנות")
            dictionary[`sec-4`] = true;
            break;
          case "sec-5":
            if (dictionary[`sec-5`]) return;
            GA_VPush(window.location.origin + window.location.pathname + (window.location.pathname[window.location.pathname.length - 1] == "/" ? "" : "/") + "reality-check/what-you-should-do", "בדיקת מציאות - מה שכדאי לעשות")
            dictionary[`sec-5`] = true;
            break;
          default:
            return;
        }

      });
    }, options);
    const wantedNodes = document.querySelectorAll(".watch");
    wantedNodes.forEach((li) => {
      observer.observe(li);
    });
  }, [loaded]);


  //Attaching the EventListener
  useEffect(() => {
    window.addEventListener("mousewheel", (event) => listenToScrollEvent(event));
    window.addEventListener("DOMMouseScroll", (event) => listenToScrollEvent(event));
    window.addEventListener("swu", (event) => listenToScrollEvent(event));
    window.addEventListener("swd", (event) => listenToScrollEvent(event));
  }, []);


  const listenToScrollEvent = (event) => {
    if (isBusy) return;
    isBusy = true;

    if (wheelDragDirection(event) == "down") {
      // scroll++;
      if (scroll <= 5) {
        document.querySelector(".down").click()
      }
    } else {
      // scroll--;
      if (scroll <= 0) {
        document.querySelector(".up").click()
      }

    }

    scroll = scroll < 0 ? 0 : scroll;
    scroll = scroll >= 5 ? 4 : scroll;

    // setScroll(scroll => scroll = scroll);
    window.setTimeout(() => {
      isBusy = false
    }, 250)
  }
  useEffect(() => {
    document.body.style.overflowX = "hidden"
  }, [])

  // useEffect(() => {
  //   console.log("loaded", loaded);
  // }, [loaded]);

  return (
    <main className="pageScroll">
      <div className="main-wrapper" style={{
        transform: `translateY(${-100 * scroll}vh)`
      }}>
        {loading && <Loading />}
        {(loaded && <>
          <Welcome />
          <VideoVR />
          <ShouldKnow />
          <ShouldBuy />
          <ShouldDo />
        </>)}
      </div>
    </main>
  );
}
